import { HydratedReferenceController } from "./HydratedReferenceController.js";
/**
 * Creates a reactive state reference that hydrates
 * when the host is connected to the DOM.
 *
 * @alpha This is an experimental API and WILL change in the future without notice.
 */
export function hydrateRef(host, options) {
    new HydratedReferenceController(host, options);
}
